import { render, staticRenderFns } from "./TaskImportModal.vue?vue&type=template&id=03521bb2&scoped=true"
import script from "./TaskImportModal.vue?vue&type=script&lang=js"
export * from "./TaskImportModal.vue?vue&type=script&lang=js"
import style0 from "./TaskImportModal.vue?vue&type=style&index=0&id=03521bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03521bb2",
  null
  
)

export default component.exports